export default __webpack_public_path__ + "fonts/iconfont.7ac14186f705db36cf8a7c35c16df189.ttf";